import React, {  useEffect,useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css'

import { FaWhatsapp } from "react-icons/fa";


import ScrollToTop from './Webpages/ScrollToTop'

import WebHeader from './Components/WebHeader'
import WebFooter from './Components/WebFooter'
import HomePage from './Webpages/HomePage'
import About from './Webpages/About';
import ProductPage from './Webpages/ProductPage';
import Contact from './Webpages/Contact';
import Blogs from './Webpages/Blogs';
import Gallery from './Webpages/Gallery';

import logoarrow from '../src/Assets/Images/site-icon.jpg'







// Pages
const App = () => {

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

 

  return (
    <BrowserRouter>
      
        <WebHeader/>
        <div>
          <ScrollToTop/>
        <Routes>

          <Route path="*" name="HomePage" element={<HomePage />} />
          <Route path="/" name="HomePage" element={<HomePage/>} />
           <Route path="/aboutus" name="About" element={<About/>} />
         <Route path="/services" name="Services" element={<ProductPage/>} />
         <Route path="/gallery" name="Gallery" element={<Gallery/>} />
         <Route path="/newsandevents" name="News & Eventss" element={<Blogs/>} />
         <Route path="/contact" name="Contact" element={<Contact/>} />
         
          
        </Routes>
        <a
          href="https://api.whatsapp.com/send/?phone=7798737751 &text=Hello%2C&type=phone_number&app_absent=0"
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
          title="Chat with us!"
        >
          <FaWhatsapp />
        </a>
        {/* Scroll-To-Top Button */}
        
        {/* {showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
<PiPaperPlaneFill  />

  </button>

)} */}

{showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
    <img src={logoarrow} alt="Scroll to top" 
    style={{ width: '30px', height: '30px' }} />
  </button>
)}


        </div>
     <WebFooter/>
      
    </BrowserRouter>
  )
}

export default App
